import { render } from "./ExamResult.vue?vue&type=template&id=4d0a3d2d&scoped=true"
import script from "./ExamResult.vue?vue&type=script&lang=js"
export * from "./ExamResult.vue?vue&type=script&lang=js"

import "./ExamResult.vue?vue&type=style&index=0&id=4d0a3d2d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0a3d2d"]])

export default __exports__